
class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  handleDefault() {
    const message = this.createChatBotMessage("Przepraszam, nie zrozumiałem. Czy możesz powtórzyć?");
    this.setState(prev => ({ ...prev, messages: [...prev.messages, message] }));
  }
}

export default ActionProvider;
